import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  AfterViewInit,
  AfterContentInit,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  NgControlStatus,
} from '@angular/forms';
import { RequiredSelectValidator } from '../../validator/required-select/required-select.validator';
import { MobilePhoneNumberValidator } from '../../validator/mobilephonenumber/mobilephonenumber.validators';
import { AlphabetValidator } from '../../validator/alphabet/alphabet.validator';
import { NumericalValidator } from '../../validator/numerical/numerical.validator';
import { EmailValidator } from '../../validator/email/email.validator';
import { NoSpaceValidator } from '../../validator/no-space/no-space.validator';
import { Router, NavigationEnd } from '@angular/router';
import * as Cookies from 'js-cookie';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';

declare var mixpanel: any;
export class B2BTNKLoanSliderComponent
  implements OnInit, AfterViewInit, AfterContentInit {
private sliderData: any = {
    loanAmount: 10000000,
    loanPeriod: 12,
    loanMonthly: 0,
  };
private state2Form: FormGroup;
private routes: any[];
private agentRoutes: any[];
private invalidSliderForm: boolean = false;
public activeIndexURI: number;
public actionBusy: boolean = false;
public errorMsg: string;
private landingPageSubmitSuccess: boolean = false;
public saveStep1Succeed: boolean = false;
public cardSliderStyle: string;
private activeForm: boolean = false;
private notFirstApplicant: boolean = false;
private formErrors: any = {
    name: '',
    emailAddress: '',
    mobilePhoneNumber: '',
    mediasource: '',
    loanPurpose: '',
    emailIsOwn: '',
  };
private validationMessages: any = {
    name: {
      required: 'Nama lengkap wajib diisi',
      noSpace: 'Nama lengkap tidak boleh diawali spasi',
      minlength: 'Nama lengkap minimal 1 karakter',
      maxlength: 'Nama lengkap maksimal 50 karakter',
      requiredSelect: 'Nama lengkap wajib diisi',
      alphabetonly: 'Nama hanya boleh berupa alphabet',
    },
    emailAddress: {
      required: 'Alamat email wajib diisi',
      customEmail: 'Alamat email tidak sesuai format',
      maxlength: 'Alamat email maksimum adalah 50 karakter',
    },
    mobilePhoneNumber: {
      required: 'Nomor handphone wajib diisi',
      maxlength: 'Nomor handphone maksimal 13 karakter',
      customMobilePhoneNumber: 'Format Nomor Handphone tidak sesuai',
      minlength: 'Nomor handphone minimal 10 karakter',
      numerical: 'Nomor handphone hanya diperbolehkan angka',
    },
    mediasource: {
      requiredSelect: 'Sumber media wajib diisi',
    },
    loanPurpose: {
      requiredSelect: 'Tujuan pinjaman wajib diisi',
    },
    emailIsOwn: {
      requiredSelect: 'Kepemilikan Email wajib diisi',
    },
  };
public referralForm: boolean = false;
public elementState: number = 0;
public stateURI: boolean;
public cookieService: any;
public createAccountURI: string;
public formURI: string;
public startURI: string;
public sliderOnly: boolean;
public customerIp: string;
public referralFormURI: string;
public requestsource: string;
public sliderColor: string;
public encryptedRefCode: string;
public micrositePurpose: boolean;
public sliderEvent = new EventEmitter<object>();
public purposeEvent = new EventEmitter<string>();
/**
 * @param {?} fb
 * @param {?} router
 * @param {?} api
 * @param {?} http
 */
constructor(
private fb: FormBuilder,
private router: Router,
public api: ApiConstant,
private http: HttpClient,
  ) {
    this.routes = [];
    this.routes = [
      this.startURI ? this.startURI : '/',
      this.createAccountURI
        ? this.createAccountURI
        : '/loan/b2b/create-account',
      this.formURI,
    ];
    this.agentRoutes = ['/loan/referral-widget'];
    this.sliderColor = this.sliderColor ? this.sliderColor : '#004c7b';

    if (!this.micrositePurpose) {
      this.determineWhichElementStateToRender();
    }

    // if(Cookies.get('savestep1succeed')){
    // 	this.saveStep1Succeed = Cookies.get('savestep1succeed');
    // }

    // if(!Cookies.get('tracer_token')){
    // 	console.log('TRACER TOKEN NOT EXIST')
    // 	this.getTracerToken();
    // }
  }
/**
 * @return {?}
 */
ngOnInit() {}
/**
 * @return {?}
 */
ngAfterViewInit() {
    if (this.micrositePurpose) {
      this.determineWhichElementStateToRender();
    }
  }
/**
 * @return {?}
 */
ngAfterContentInit(): void {
    let /** @type {?} */ loanData: any;
/**
 * @param {?} loanData
 * @return {?}
 */
function setInitData(loanData) {
      if (!loanData.loanAmount && !loanData.loanPeriod) {
        const /** @type {?} */ defaultLoanData = ( /** @type {?} */((<any>Object))).assign(loanData, {
          loanAmount: 10000000,
          loanPeriod: 12,
          loanMonthly: 0,
        });

        this.sliderData = defaultLoanData;
      } else {
        this.sliderData = loanData;
      }

      this.calcInitMonthly();
    }

    try {
      if (this.cookieService.get('TNK-LNDATA')) {
        loanData = this.cookieService.get('TNK-LNDATA');
        setInitData.call(this, loanData);
      }
    } catch ( /** @type {?} */e) {
      if (Cookies.getJSON('TNK-LNDATA')) {
        loanData = Cookies.getJSON('TNK-LNDATA');
        setInitData.call(this, loanData);
      }
    }
  }
/**
 * @return {?}
 */
private determineWhichElementStateToRender() {
    this.routes[0] = this.startURI ? this.startURI : '/';
    this.routes[1] = this.createAccountURI
      ? this.createAccountURI
      : '/loan/b2b/create-account';
    this.routes[2] = this.formURI;
    this.sliderColor = this.sliderColor ? this.sliderColor : '#004c7b';

    const /** @type {?} */ loanData = Cookies.get('TNK-LNDATA')
      ? Cookies.getJSON('TNK-LNDATA')
      : null;

    this.calcInitMonthly();

    if (this.routes.indexOf(window.location.pathname.split('?')[0]) > -1) {
      if (!this.referralForm) {
        this.activeIndexURI = this.routes.indexOf(
          window.location.pathname.split('?')[0],
        );
      }

      if (!this.sliderOnly && !this.stateURI) {
        if (Cookies.get('savestep1succeed') === 'true') {
          this.elementState = 3;
        } else {
          if (!this.referralForm) {
            this.elementState =
              this.routes.indexOf(window.location.pathname.split('?')[0]) + 1;
          } else {
            this.elementState =
              this.agentRoutes.indexOf(window.location.pathname.split('?')[0]) +
              1;
          }
        }
      } else {
        if (!this.sliderOnly) {
          if (Cookies.get('savestep1succeed') === 'true') {
            this.elementState = 3;
          } else {
            this.elementState =
              this.routes.indexOf(window.location.pathname.split('?')[0]) + 1;
          }
        } else {
          this.elementState = 1;
        }
      }
    }
  }
/**
 * @return {?}
 */
private getBrowserInformation() {
    const /** @type {?} */ browserInformation = navigator.userAgent;

    let /** @type {?} */ browserType;
    if (browserInformation.includes('Chrome')) {
      browserType = 'Chrome';
    } else if (browserInformation.includes('Firefox')) {
      browserType = 'Firefox';
    } else if (browserInformation.includes('Safari')) {
      browserType = 'Safari';
    } else if (browserInformation.includes('Opera')) {
      browserType = 'Opera';
    } else if (browserInformation.includes('MSIE')) {
      browserType = 'Microsoft Internet Explorer';
    } else if (browserInformation.includes('Mobile')) {
      browserType = 'Mobile Browser';
    } else {
      browserType = 'Unknown Browser';
    }

    return browserType;
  }
/**
 * @return {?}
 */
private calcInitMonthly() {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];

    const /** @type {?} */ loanAmount = this.sliderData.loanAmount;
    const /** @type {?} */ loanPeriod = this.sliderData.loanPeriod;

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    ret[0] = monthlyPaymentRaw;
    ret[1] = monthlyPaymentRaw * loanPeriod;

    this.sliderData.loanMonthly = ret[0];
  }
/**
 * @param {?=} event
 * @param {?=} type
 * @return {?}
 */
private calcMonthly(event?: any, type?: string): void {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];
    let /** @type {?} */ loanAmount = 0;
    let /** @type {?} */ loanPeriod = 0;

    if (event && type === 'amount') {
      loanAmount = parseInt(event.value);
      this.sliderData.loanAmount = loanAmount;
    } else if (event && type === 'period') {
      loanPeriod = parseInt(event.value);
      this.sliderData.loanPeriod = loanPeriod;
    }

    loanAmount = this.sliderData.loanAmount;
    loanPeriod = this.sliderData.loanPeriod;

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    ret[0] = monthlyPaymentRaw;
    ret[1] = monthlyPaymentRaw * loanPeriod;

    this.sliderData.loanMonthly = ret[0];

    this.sliderEvent.emit({
      loanAmount: loanAmount,
      loanPeriod: loanPeriod,
      loanMonthly: ret[0],
    });
  }
/**
 * @param {?} status
 * @return {?}
 */
private handleFirstApplicant(status: boolean) {
    if (status) {
      this.buildState2Form();
      this.activeForm = status;
      this.notFirstApplicant = false;
    } else {
      this.activeForm = status;
      this.notFirstApplicant = true;
    }
  }
/**
 * @param {?} val
 * @return {?}
 */
private handleLoanPurpose(val: any): void {
    if (val === '0') {
      this.invalidSliderForm = true;
    } else {
      this.invalidSliderForm = false;
    }

    this.purposeEvent.emit(val);
  }
/**
 * @param {?} step
 * @param {?=} action
 * @return {?}
 */
private stateHandler(step: number, action?: boolean): void {
    this.invalidSliderForm = false;
    const /** @type {?} */ refForm = Cookies.get('TNK-REFFORM');

    switch (step) {
      case 1: {
        try {
          Cookies.set('TNK-LNDATA', JSON.stringify(this.sliderData), {
            expires: 1,
          });
        } catch ( /** @type {?} */e) {}

        this.elementState = 2;
        break;
      }

      case 2: {
        if (this.state2Form.valid) {
          const /** @type {?} */ formValue = ( /** @type {?} */((<any>Object))).assign({}, this.state2Form.value);
          this.mixpanelIdentify(formValue);

          formValue.mobilePhoneNumber = `+62${formValue.mobilePhoneNumber}`;
          formValue.name = formValue.name;

          const /** @type {?} */ data = JSON.parse(Cookies.get('TNK-LNDATA'));
          const /** @type {?} */ tmp = ( /** @type {?} */((<any>Object))).assign(data, formValue);

          // update TNK-LNDATA cookies
          Cookies.set('TNK-LNDATA', JSON.stringify(tmp), {
            expires: 1,
          });

          if (!this.actionBusy)
            this.saveStep1LoanData(Cookies.get('TNK-LNDATA'));
        }

        break;
      }

      default: {
        console.error('Step is not specified (50:10) at loan-slider.component');
        break;
      }
    }
  }
/**
 * @return {?}
 */
private getTracerToken() {
    this.http.get(`${this.api.partnerApiURL}/pagetrack/tracer/token`).subscribe(
      (res: any) => {
        Cookies.set('tracer_token', res.data.tracer_key, { expires: 1 });
      },
      (error: HttpErrorResponse) => {
        // tslint:disable-next-line
        console.log(error);
      },
    );
  }
/**
 * @param {?} data
 * @return {?}
 */
private saveStep1LoanData(data) {
    this.actionBusy = true;

    const /** @type {?} */ loanData = JSON.parse(data);

    const /** @type {?} */ deviceInformation = navigator.userAgent.split(')')[0].split('(')[1];
    const /** @type {?} */ platform = navigator.platform;
    const /** @type {?} */ browserType = this.getBrowserInformation();

    const /** @type {?} */ headers = new HttpHeaders();
    headers.append('access-token', Cookies.get('tracer_token'));

    const /** @type {?} */ refData = JSON.parse(Cookies.get('TNK-REFDATA'));
    const /** @type {?} */ loanStep1 = {
      editData: 1,
      emailIsOwn: loanData.emailIsOwn,
      loanAmount: loanData.loanAmount.toString(),
      loanPeriodInMonths: loanData.loanPeriod.toString(),
      haveLoanInTunaiku: 'false',
      fullName: loanData.name,
      mobilePhoneNumber: loanData.mobilePhoneNumber,
      emailAddress: loanData.emailAddress,
      mediaSource: 'Other',
      loanPurposeType: loanData.loanPurpose,
      referralCode: this.encryptedRefCode
        ? this.encryptedRefCode
        : refData.refCode,
      referralType: refData.refType,
      browserTools: `${browserType} ${platform} ${deviceInformation}`,
      costumerIp: this.customerIp,
      requestsource: this.requestsource,
    };

    this.http
      .put(`${this.api.partnerApiURL}/pagetrack/tracer/1`, loanStep1, {
        headers: headers,
      })
      .subscribe(
        (res: any) => {
          this.actionBusy = false;
          this.errorMsg = null;
          this.setStep1SucceedIntoCookies('true');

          setTimeout(() => {
            this.router.navigateByUrl(this.formURI);
            window.scrollTo(0, 0);
            window.parent.parent.scrollTo(0, 0);
          }, 100);
        },
        (err: HttpErrorResponse) => {
          this.actionBusy = false;
          this.errorMsg = err.error.data.reason;
          this.setStep1SucceedIntoCookies('false');
        },
      );
  }
/**
 * @param {?} isSucceed
 * @return {?}
 */
private setStep1SucceedIntoCookies(isSucceed) {
    Cookies.set('savestep1succeed', isSucceed);
    this.saveStep1Succeed = Cookies.get('savestep1succeed');
  }
/**
 * @return {?}
 */
private buildState2Form(): void {
    this.state2Form = this.fb.group({
      name: [
        this.sliderData.name ? this.sliderData.name : '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          NoSpaceValidator(),
          RequiredSelectValidator(),
          AlphabetValidator(),
        ],
      ],
      emailAddress: [
        this.sliderData.emailAddress ? this.sliderData.emailAddress : '',
        [Validators.required, EmailValidator(), Validators.maxLength(49)],
      ],
      mobilePhoneNumber: [
        this.sliderData.mobilePhoneNumber
          ? this.sliderData.mobilePhoneNumber.replace('+62', '')
          : '',
        [
          Validators.required,
          NumericalValidator(),
          MobilePhoneNumberValidator(),
          Validators.maxLength(13),
          Validators.minLength(10),
        ],
      ],
      mediasource: ['Other', [RequiredSelectValidator()]],
      loanPurpose: [
        this.sliderData.loanPurpose ? this.sliderData.loanPurpose : '0',
        [RequiredSelectValidator()],
      ],
      emailIsOwn: [
        this.sliderData.emailIsOwn ? this.sliderData.emailIsOwn : '0',
        [RequiredSelectValidator()],
      ],
    });
/**
 * @param {?} data
 * @return {?}
 */
function onValueChanged(data: any) {
      if (!this.state2Form) {
        return;
      }
      const /** @type {?} */ form = this.state2Form;

      for (const /** @type {?} */ field in this.formErrors) {
        if (this.formErrors.hasOwnProperty(field)) {
          this.formErrors[field] = '';
          const /** @type {?} */ control = form.get(field);

          if (control && control.dirty && !control.valid) {
            for (const /** @type {?} */ key in control.errors) {
              if (control.errors.hasOwnProperty(key)) {
                this.formErrors[
                  field
                ] = `${this.validationMessages[field][key]} `;
              }
            }
          }
        }
      }
    }

    this.state2Form.valueChanges.subscribe(data =>
      onValueChanged.apply(this, data),
    );
  }
/**
 * @param {?} status
 * @return {?}
 */
private sessionHandler(status: boolean) {
    const /** @type {?} */ refForm = Cookies.get('TNK-REFFORM');

    switch (status) {
      case true: {
        if (refForm) {
          location.href = this.referralFormURI;
        } else {
          location.href = this.formURI;
        }

        break;
      }

      case false: {
        // remove session and updated element state

        Cookies.remove('TNK-LNDATA');
        Cookies.remove('TNK-FORM5');
        Cookies.remove('tracer_token');
        Cookies.remove('TNKActiveStep');
        Cookies.remove('savestep1succeed');
        this.setStep1SucceedIntoCookies('false');

        this.getTracerToken();

        this.sliderData = {
          loanAmount: 10000000,
          loanPeriod: 12,
          loanMonthly: 0,
        };

        this.calcMonthly(
          this.sliderData.loanAmount,
          this.sliderData.loanPeriod,
        );

        if (this.stateURI) {
          this.elementState = 1;
          if (this.startURI) {
            this.router.navigateByUrl(this.startURI);
          } else {
            this.router.navigateByUrl('/');
          }
        } else {
          this.elementState = 1;
        }

        break;
      }
    }
  }
/**
 * @param {?} obj
 * @return {?}
 */
private mixpanelIdentify(obj: any) {
    if (typeof mixpanel !== 'undefined') {
      mixpanel.reset();
      mixpanel.alias(obj.name);
      mixpanel.people.set({
        $email: obj.emailAddress,
        $first_name: obj.name,
      });
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'b2b-tnk-loan-slider',
  template: `
    <!-- If element state == 1 -->
    <ng-container *ngIf="elementState == 1">
      <div class="loan__slider__widget" [class.widget--embed]="sliderOnly">
        <div
          class="card card--loan-slider card--no-padding"
          [style.background-color]="sliderColor"
        >
          <!--card--bg-blue-->
          <div class="col-sm-3 col-xs-4">
            <p class="loan__description text--left text--clr-white text--big">
              Cicilan
            </p>
          </div>

          <div class="col-sm-9 col-xs-8">
            <p class="align--right text--padding-top">
              <span class="loan__amount">
                {{ sliderData.loanMonthly | tnkCurrency: 'rupiah' }},-
              </span>
              <br />
              <span>per bulan</span>
            </p>
          </div>
        </div>

        <div class="card card--loan-slider side--margin">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <p class="help-block">Jumlah Pinjaman</p>
            </div>

            <div class="col-sm-6 col-xs-6 align--right">
              <p class="slider-title">
                {{ 'Rp ' + sliderData.loanAmount / 1000000 + ' juta' }}
              </p>
            </div>
          </div>

          <div class="row row--slider">
            <div class="col-sm-12">
              <div class="col-sm-1 col-xs-1" style="padding: 0">
                <p class="loan__description">2</p>
              </div>

              <div
                class="col-sm-10 col-xs-10"
                style="padding: 0"
                id="slider_jumlahPinjaman"
              >
                <mat-slider
                  [min]="2000000"
                  [max]="20000000"
                  [(ngModel)]="sliderData.loanAmount"
                  [step]="1000000"
                  (input)="calcMonthly($event, 'amount')"
                ></mat-slider>
                <!-- <input type="range" min="2000000" max="20000000" step="1000000" id="slider_loanAmount" value="10000000" [(ngModel)]="sliderData.loanAmount" name="loan_amount" (input)="calcMonthly(sliderData.loanAmount, sliderData.loanPeriod, 'amount')"> -->
              </div>

              <div class="col-sm-1 col-xs-1" style="padding: 0">
                <p class="loan__description">20</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card card--loan-slider side--margin">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <p class="help-block">Periode Pinjaman</p>
            </div>

            <div class="col-sm-6 col-xs-6 align--right">
              <p class="slider-title">{{ sliderData.loanPeriod + ' bulan' }}</p>
            </div>
          </div>

          <div class="row row--slider">
            <div class="col-sm-12">
              <div class="col-sm-1 col-xs-1" style="padding: 0">
                <p class="loan__description">6</p>
              </div>

              <div
                class="col-sm-10 col-xs-10"
                style="padding: 0"
                id="slider_periodePinjaman"
              >
                <mat-slider
                  [min]="6"
                  [max]="20"
                  [(ngModel)]="sliderData.loanPeriod"
                  [step]="1"
                  (input)="calcMonthly($event, 'period')"
                ></mat-slider>
                <!-- <nouislider [connect]="[true, false]" [min]="6" [max]="20" [(ngModel)]="sliderData.loanPeriod" [step]="1" (ngModelChange)="calcMonthly(sliderData.loanAmount, sliderData.loanPeriod)"></nouislider> -->

                <!-- <input type="range" min="6" max="20" value="12" step="1" id="slider_loanPeriod" [(ngModel)]="sliderData.loanPeriod" name="loan_period" (input)="calcMonthly(sliderData.loanAmount, sliderData.loanPeriod, 'period')" /> -->
              </div>

              <div class="col-sm-1 col-xs-1" style="padding: 0">
                <p class="loan__description">20</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card card--loan-slider side--margin">
          <div class="row" *ngIf="!sliderOnly || referralForm">
            <button
              id="homeBtn_ajukanPinjaman"
              class="tnk__button button--green button--block"
              (click)="stateHandler(1)"
            >
              Ajukan Pinjaman
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- End if element state == 1 -->

    <!-- If element state == 2 -->
    <ng-container *ngIf="elementState == 2">
      <div class="loan__slider__widget">
        <div class="card card--loan-content card--bg-grey">
          <div class="col-sm-6 col-xs-6">
            <p>
              Pinjaman
              <b>Rp {{ this.sliderData.loanAmount / 1000000 }} Juta</b>
            </p>
          </div>

          <div class="col-sm-6 col-xs-6">
            <p>
              Lama cicilan
              <b>{{ this.sliderData.loanPeriod }} Bulan</b>
            </p>
          </div>

          <div class="col-sm-12">
            <p>
              Cicilan per bulan
              <strong>
                {{ this.sliderData.loanMonthly | tnkCurrency: 'rupiah' }},-
              </strong>
            </p>

            <a
              id="homeBtn_kembali_Info_Pinjaman"
              class="link link--clr-blue"
              [routerLink]="routes[0]"
              *ngIf="stateURI"
            >
              <span class="back__circle">
                <
              </span>
              Kembali ke info pinjaman
            </a>

            <a
              id="inp_backToInfo"
              class="link link--clr-blue"
              href="javascript:void(0)"
              *ngIf="!stateURI"
              (click)="elementState = 1"
            >
              <span class="back__circle">
                <
              </span>
              Kembali ke info pinjaman
            </a>
          </div>
        </div>

        <div class="card card--confirm-action row">
          <div class="col-sm-12">
            <p>Apakah Anda pernah mengajukan pinjaman di Tunaiku?</p>
          </div>

          <div class="col-sm-12 align--right">
            <button
              id="inp_Ya_PinjamanPertama"
              class="tnk__button button--green button--hole button--float-right"
              (click)="handleFirstApplicant(true)"
              [ngClass]="{ 'button--active': activeForm && !notFirstApplicant }"
            >
              BELUM PERNAH
            </button>
            <button
              id="inp_Tidak_PinjamanPertama"
              class="tnk__button button--green button--hole button--float-right"
              (click)="handleFirstApplicant(false)"
              [ngClass]="{ 'button--active': notFirstApplicant && !activeForm }"
            >
              SUDAH PERNAH
            </button>
          </div>
        </div>

        <ng-container *ngIf="notFirstApplicant">
          <div class="separator">&nbsp;</div>

          <div class="card card--loan-content">
            <div class="col-sm-12">
              <p class="help-block">Masuk ke akun anda untuk:</p>
              <ul class="tnk-list tnk-list--check">
                <li class="tnk-list__item">Cek status pengajuan Anda</li>
                <li class="tnk-list__item">Pantau dan cek info cicilan pinjaman</li>
                <li class="tnk-list__item">
                  Ajukan pinjaman berikutnya tanpa isi formulir
                </li>
              </ul>

              <a
                target="_blank"
                type="button"
                role="button"
                class="text-center tnk__button button--green button--block"
                href="{{ api.tunaikuClient + '/customer/login' }}"
                id="inp_formMasukAkun"
              >
                Masuk ke Akun Anda
              </a>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="activeForm">
          <div class="separator">&nbsp;</div>

          <div class="card card--loan-content">
            <div class="col-sm-12">
              <p>
                <b>Isi Formulir Pengajuan</b>
              </p>

              <form
                class="form-wrapper"
                [formGroup]="state2Form"
                (ngSubmit)="stateHandler(2)"
                autocomplete="off"
              >
                <div
                  class="form-group"
                  [ngClass]="{ 'has-error': formErrors.name }"
                >
                  <label class="help-block">Nama Lengkap</label>

                  <input
                    id="field_namalengkap"
                    type="text"
                    class="form-control"
                    name="name"
                    formControlName="name"
                  />

                  <span class="help-block">{{ formErrors.name }}</span>
                </div>

                <div
                  class="form-group"
                  [ngClass]="{ 'has-error': formErrors.mobilePhoneNumber }"
                >
                  <label class="help-block">Nomor Handphone</label>

                  <div class="input-group">
                    <span class="input-group-addon">+62</span>
                    <input
                      id="field_nomorhandphone"
                      type="text"
                      class="form-control"
                      name="mobilePhoneNumber"
                      formControlName="mobilePhoneNumber"
                    />
                  </div>

                  <span class="help-block" *ngIf="formErrors.mobilePhoneNumber">
                    {{ formErrors.mobilePhoneNumber }}
                  </span>
                </div>

                <div
                  class="form-group"
                  [ngClass]="{ 'has-error': formErrors.emailAddress }"
                >
                  <label class="help-block">Alamat Email</label>
                  <input
                    id="field_email"
                    type="email"
                    class="form-control"
                    formControlName="emailAddress"
                    name="emailAddress"
                  />

                  <span class="help-block">{{ formErrors.emailAddress }}</span>
                </div>

                <div
                  class="form-group"
                  [ngClass]="{ 'has-error': formErrors.emailIsOwn }"
                >
                  <label class="help-block">Kepemilikan Email</label>
                  <select
                    class="form-control"
                    id="field_kepemilikanEmail"
                    name="emailIsOwn"
                    formControlName="emailIsOwn"
                  >
                    <option value="0">Pilih salah satu</option>
                    <option value="Personal">Email Pribadi</option>
                    <option value="Corporate">Email Kantor</option>
                    <option value="Other">Lainnya</option>
                  </select>
                  <span class="help-block" *ngIf="formErrors.emailIsOwn">
                    {{ formErrors.emailIsOwn }}
                  </span>
                </div>

                <div
                  class="form-group"
                  [ngClass]="{ 'has-error': formErrors.loanPurpose }"
                >
                  <label class="help-block" style="margin-top: 10px">
                    Tujuan Pinjaman
                  </label>

                  <select
                    class="form-control"
                    id="reviewField_tujuan_meminjam"
                    name="loanPurpose"
                    formControlName="loanPurpose"
                  >
                    <option value="0">Pilih salah satu</option>
                    <option value="Holiday">Liburan</option>
                    <option value="HousingLoan">KPR</option>
                    <option value="CarOrMotorcycle">Mobil/Motor</option>
                    <option value="CreditCard">Kartu Kredit</option>
                    <option value="Renovation">Renovasi</option>
                    <option value="ElectronicUnsecuredLoan">KTA Elektronik</option>
                    <option value="Education">Sekolah</option>
                    <option value="VentureCapital">Modal Usaha</option>
                    <option value="Investment">Investasi</option>
                    <option value="Bills">Tagihan</option>
                    <option value="Other">Lainnya</option>
                  </select>

                  <span class="help-block" *ngIf="formErrors.loanPurpose">
                    {{ formErrors.loanPurpose }}
                  </span>
                </div>

                <div *ngIf="errorMsg" class="alert alert-danger text-center">
                  <strong>{{ errorMsg }}</strong>
                </div>

                <div class="form-group">
                  <button
                    id="inp_lanjutFormulir"
                    class="tnk__button button--green button--block"
                    type="submit"
                    [disabled]="state2Form.invalid || actionBusy"
                  >
                    Lanjut Isi Formulir Pengajuan
                  </button>
                </div>
              </form>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <!-- End if element state == 2 -->

    <!-- If element state == 3 -->
    <ng-container *ngIf="elementState == 3">
      <div class="loan__slider__widget">
        <div class="card card--loan-content no--pd-bot">
          <div class="col-sm-12">
            <h2>Ingin melanjutkan formulir yang telah Anda isi?</h2>

            <table class="table table--borderless">
              <tr>
                <td>
                  <b>Atas Nama</b>
                </td>
                <td>
                  {{ sliderData.ktpName ? sliderData.ktpName : sliderData.name }}
                </td>
              </tr>

              <tr>
                <td>
                  <b>Nomor Handphone</b>
                </td>
                <td>{{ sliderData.mobilePhoneNumber }}</td>
              </tr>

              <tr>
                <td>
                  <b>Jumlah Pinjaman</b>
                </td>
                <td>Rp {{ sliderData.loanAmount / 1000000 }} Juta</td>
              </tr>

              <tr>
                <td>
                  <b>Lama Cicilan</b>
                </td>
                <td>{{ sliderData.loanPeriod }} Bulan</td>
              </tr>
            </table>
          </div>
        </div>

        <div class="card card--loan-content no--pd-top">
          <div class="col-sm-12 align--right">
            <button
              class="tnk__button button--green button--float-right button--sm"
              (click)="sessionHandler(true)"
            >
              Lanjutkan
            </button>

            <button
              class="tnk__button button--green button--hole button--float-right"
              (click)="sessionHandler(false)"
            >
              Batalkan
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- End if element state == 3 -->
  `,
  styles: [`
    html {
      font-size: 14px;
    }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
    }
    #loan-slider .card__header {
      background-color: #004c7b;
      color: #fff;
    }
    .pd-left-right-20 {
      padding-left: 20px;
      padding-right: 20px;
    }
    .separator {
      position: relative;
      width: 100%;
      height: 1px;
      display: block;
      overflow: hidden;
      background-color: #ececec;
      margin: 5px auto;
    }
    .separator:after {
      content: ' ';
    }
    .table.table--borderless td,
    .table.table--borderless th {
      border: none;
    }
    .table.table--borderless td {
      font-size: 14px;
    }
    .separator {
      position: relative;
      display: block;
      height: 1px;
      width: 100%;
      background-color: #ccc;
      margin-bottom: 10px;
    }
    .no--margin {
      margin: 0 !important;
    }
    a.link {
      -webkit-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
    }
    a.link.link--clr-blue:link {
      color: #004c7b;
    }
    .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group {
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
    }
    .form-wrapper .form-group.align--center {
      text-align: center;
    }
    .form-wrapper .form-group .help-block {
      font-size: 13px;
    }
    .form-wrapper .form-group .help-block.label--control {
      color: #444;
    }
    .form-wrapper .form-group .col-sm-* p {
      margin-bottom: 15px;
    }
    a.tnk__button {
      text-decoration: none;
    }
    .tnk__button {
      position: relative;
      display: inline-block;
      min-width: 70px;
      padding: 10px;
      -webkit-appearance: none;
         -moz-appearance: none;
              appearance: none;
      outline: 0;
      cursor: pointer;
      border: 1px solid transparent;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin: 0 auto;
      border-radius: 35px;
      -webkit-box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
              box-shadow: 0 2px 4.8px 0.3px rgba(0,0,0,0.25);
      text-transform: uppercase;
      margin-top: 15px;
    }
    .tnk__button[disabled] {
      cursor: not-allowed;
    }
    .tnk__button.button--sm {
      font-size: 12px;
    }
    .tnk__button.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
    }
    .tnk__button.button--block {
      min-width: 100%;
      width: 100%;
      padding: 10px 0;
    }
    .tnk__button.button--float-right {
      float: right;
      margin-right: 10px;
    }
    .tnk__button.button--float-left {
      float: left;
      margin-left: 10px;
    }
    .tnk__button.button--min {
      width: 110px;
      padding: 10px 5px;
      margin-bottom: 5px;
    }
    .tnk__button.button--green {
      font-size: 12px;
      color: #fff;
      background-color: #81be41;
    }
    .tnk__button.button--green.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--green:hover {
      background-color: #72b63e;
    }
    .tnk__button.button--green:active {
      color: #f2f2f2;
      bakground-color: #6ab631;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--green[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--green.button--sm {
      -webkit-box-shadow: none;
              box-shadow: none;
      padding: 8.5px 10px;
    }
    .tnk__button.button--blue {
      background-color: #1a72a4;
      color: #fff;
      font-size: 12px;
    }
    .tnk__button.button--blue.button--lg {
      font-size: 14px;
    }
    .tnk__button.button--blue:hover {
      background-color: #1e6a94;
      color: #fff;
    }
    .tnk__button.button--blue:active {
      color: #f2f2f2;
      background-color: #004c7b;
      -webkit-box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
              box-shadow: inset 2px 6px 3px rgba(0,0,0,0.075);
    }
    .tnk__button.button--blue[disabled] {
      background-color: #b7b7b7;
      color: #fff;
    }
    .tnk__button.button--blue.button--min {
      font-size: 10px;
    }
    .tnk__button.button--red {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole {
      border-radius: 16.5px;
      padding: 7px 10px;
    }
    .tnk__button.button--hole.button--red {
      background-color: #fff;
      border: 2px solid #721c24;
      color: #721c24;
    }
    .tnk__button.button--hole.button--red:hover,
    .tnk__button.button--hole.button--red :active {
      background-color: #721c24;
      color: #fff;
    }
    .tnk__button.button--hole.button--green {
      background-color: transparent;
      border: 2px solid #81be41;
      color: #81be41;
    }
    .tnk__button.button--hole.button--green.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--green.button--active {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--green.button--active:hover,
    .tnk__button.button--hole.button--green.button--active :active {
      background-color: #6ab631;
    }
    .tnk__button.button--hole.button--green:hover {
      background-color: #81be41;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue {
      background-color: transparent;
      border: 2px solid #1a72a4;
      color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue.button--lg {
      font-size: 14px;
      font-weight: bold;
      padding: 15px 30px;
      border-radius: 15.5px;
    }
    .tnk__button.button--hole.button--blue.button--active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue.button--active:hover,
    .tnk__button.button--hole.button--blue.button--active :active {
      background-color: #1a72a4;
    }
    .tnk__button.button--hole.button--blue:hover,
    .tnk__button.button--hole.button--blue :active {
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--hole.button--blue[disabled] {
      border: 2px solid transparent;
      background-color: #1a72a4;
      color: #fff;
    }
    .tnk__button.button--margin-sm {
      margin-top: 5px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button.button--margin-md {
      margin-top: 10px;
      margin-right: 15px;
      min-width: 200px;
    }
    .tnk__button .icon {
      margin-right: 10px;
    }
    .tnk__modal {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5000;
      width: 100%;
      height: 100vh;
      overflow: hidden;
      background-color: rgba(0,0,0,0.75);
    }
    .tnk__modal .modal__inner {
      position: relative;
      border-radius: 8px;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
              box-shadow: 0 0 5px 3px rgba(0,0,0,0.25);
      width: 80%;
      min-height: 240px;
      margin: 7.5% auto 0;
      display: block;
    }
    .tnk__modal .modal__inner.modal--size-small {
      width: 30%;
      border-radius: 8px;
      min-height: 120px;
      margin: 0 auto;
    }
    .tnk__modal .modal__inner.modal--size-small .modal__content {
      margin-top: 25vh;
      padding: 30px;
    }
    .tnk__modal .modal__inner .modal__content {
      position: relative;
      display: block;
      overflow: hidden;
    }
    .tnk__modal .modal__inner .modal__content.content--align-center {
      text-align: center;
    }
    .tnk__modal .modal__inner .modal__content h4 {
      font-size: 22px;
      color: #81be41;
    }
    .tnk__modal .modal__inner .modal__content .head__icon {
      font-size: 48px;
    }
    .tnk__modal .modal__inner .modal__content p {
      color: #8a8989;
      margin-top: 28px;
    }
    .checkbox__wrapper {
      position: relative;
      display: block;
      overflow: hidden;
      background-color: #cfe6f0;
      padding: 20px 30px;
      border-radius: 5px;
      margin: 0 0 10px;
    }
    .checkbox__wrapper.has-error {
      background-color: #f2dede;
    }
    .checkbox__wrapper.has-error p {
      color: #721c24;
    }
    .checkbox__wrapper label {
      color: #191919;
    }
    .checkbox__wrapper label input[type=checkbox] {
      width: 16px;
      height: 16px;
      margin-left: -25px;
      margin-top: 3px;
    }
    .birth__province {
      padding-left: 0 !important;
    }
    .birth__city {
      padding-right: 0 !important;
    }
    @media screen and (min-width: 240px) and (max-width: 800px) {
      .birth__province {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .birth__city {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
      .tnk__button.button--margin-sm {
        min-width: 42.5%;
      }
      .tnk__button.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--hole.button--green.button--lg {
        padding: 10px;
      }
      .tnk__button.button--float-left {
        margin-left: 0;
      }
      .tnk__modal .modal__inner.modal--size-small {
        width: 100%;
        border-radius: 0;
        min-height: 100vh;
      }
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        margin-top: 0;
        padding: 0;
        padding-top: 25vh;
      }
    }
    @media screen and (max-width: 1024px) {
      .tnk__button.button--hole.button--green:active {
        background-color: #81be41;
        color: #fff;
      }
    }
    @media screen and (min-width: 1024px) {
      .tnk__modal .modal__inner.modal--size-small .modal__content {
        padding-top: 25;
      }
      .checkbox__wrapper {
        margin: 0 0 10px;
      }
    }
    mat-slider {
      width: 100%;
    }
    .mat-accent .mat-slider-thumb,
    .mat-accent .mat-slider-thumb-label,
    .mat-accent .mat-slider-track-fill {
      background-color: #81be41;
    }
    .noUi-connect {
      background: #81be41;
    }
    .loan__slider__widget {
      position: relative;
      margin: 5px;
      border-radius: 5px;
      background-color: #fff;
      -webkit-box-shadow: 0px -2px 9px 1px rgba(28,28,28,0.4);
              box-shadow: 0px -2px 9px 1px rgba(28,28,28,0.4);
      overflow: hidden;
      display: block;
    }
    .loan__slider__widget.widget--embed {
      -webkit-box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
              box-shadow: 0 0 3px 1px rgba(28,28,28,0.15);
      border-radius: 5px 5px 0 0;
      margin: 5px 2.9px 0 2.9px;
    }
    .loan__slider__widget .align--right {
      text-align: right;
    }
    .loan__slider__widget .align--center {
      text-align: center;
    }
    .loan__slider__widget .text--padding-top {
      padding-top: 10px;
    }
    .loan__slider__widget .row {
      position: relative;
      display: block;
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
    }
    .loan__slider__widget .row.row--slider {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 0;
      padding-bottom: 5px;
    }
    .loan__slider__widget .row.row--slider input {
      outline: none;
    }
    .loan__slider__widget .card.card--loan-slider {
      position: relative;
      display: block;
      overflow: hidden;
      border-bottom: solid 1px #ccc;
      padding: 15px 0 5px;
      font-size: 20px;
      font-weight: bold;
    }
    .loan__slider__widget .card.side--margin {
      margin: 0 5px;
    }
    .loan__slider__widget .card.side--margin:last-child {
      border-bottom: 0;
    }
    .loan__slider__widget .card.side--margin button {
      margin-bottom: 15px;
    }
    .loan__slider__widget .card.card--loan-content {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 17px 0 15px;
      border-radius: 5px 5px 0 0;
    }
    .loan__slider__widget .card.card--loan-content p,
    .loan__slider__widget .card.card--loan-content a.link:link {
      font-size: 13px;
      margin-bottom: 13px;
    }
    .loan__slider__widget .card.card--loan-content h2 {
      font-size: 18px;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      margin-bottom: 30px;
      line-height: 1.5em;
    }
    .loan__slider__widget .card.card--loan-content.no--pd-top {
      padding-top: 0;
    }
    .loan__slider__widget .card.card--loan-content.no--pd-bot {
      padding-bottom: 0;
    }
    .loan__slider__widget .card.card--loan-content .tnk-list {
      color: #444;
    }
    .loan__slider__widget .card.card--bg-grey {
      background-color: #ececec;
    }
    .loan__slider__widget .card.card--bg-blue {
      background-color: #004c7b;
      color: #fff;
      margin: 0;
      border-radius: 5px 5px 0 0;
    }
    .loan__slider__widget .card.card--no-padding {
      padding-top: 10px;
      padding-bottom: 5px;
    }
    .loan__slider__widget .card.card--confirm-action {
      position: relative;
      display: block;
      overflow: hidden;
      padding: 18px;
      text-align: left;
    }
    .loan__slider__widget .card span,
    .loan__slider__widget .card p {
      font-family: 'HelveticaLight', sans-serif;
      font-size: 13px;
    }
    .loan__slider__widget .card p {
      color: #555;
    }
    .loan__slider__widget .card p span {
      color: #fff;
    }
    .loan__slider__widget .card span.loan__amount {
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      font-size: 21px;
      color: #fff;
    }
    .loan__slider__widget .card h2 {
      color: #535353;
    }
    .loan__slider__widget .card .mat-slider-horizontal {
      height: 40px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-wrapper {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-background {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-fill {
      height: 5px;
    }
    .loan__slider__widget .card .mat-slider-horizontal .mat-slider-track-wrapper {
      height: 5px;
    }
    .loan__slider__widget .card p.help-block {
      font-weight: bold;
      font-size: 14px;
    }
    .loan__slider__widget .card p.help-block span {
      color: #fff;
    }
    .loan__slider__widget .card span.back__circle {
      border-radius: 100%;
      background-color: #004c7b;
      color: #fff;
      padding: 3px 5px;
      font-weight: bold;
      font-size: 11px;
    }
    .loan__slider__widget .card .table td {
      color: #535353;
    }
    .loan__slider__widget .card .loan__description {
      text-align: center;
      position: relative;
      margin-top: 15px;
    font-size
      color: #8a8989;
      font-weight: bold;
    }
    .loan__slider__widget .card .loan__description.text--big {
      font-size: 16px;
    }
    .loan__slider__widget .card .loan__description.text--sm {
      font-size: 11px;
    }
    .loan__slider__widget .card .loan__description.text--left {
      text-align: left;
    }
    .loan__slider__widget .card .loan__description.text--clr-white {
      color: #fff;
    }
    .loan__slider__widget .card .slider-title {
      font-size: 18px;
      font-family: 'HelveticaBold', sans-serif;
      font-weight: bold;
      padding-bottom: 0;
      margin-top: 0;
      margin-bottom: 0;
      color: #7f7f7f;
    }
    .loan__slider__widget input[type=range] {
      height: auto;
      -webkit-appearance: none;
      margin: 14px 0 0 0;
      width: 100%;
      outline: none;
    }
    .loan__slider__widget input[type=range]:focus {
      outline: none;
    }
    .loan__slider__widget input[type=range]::-webkit-slider-runnable-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      border: none;
      -webkit-box-shadow: 0px 0px 0px #000;
              box-shadow: 0px 0px 0px #000;
      background: #ececec;
      border-radius: 25px;
    }
    .loan__slider__widget input[type=range]::-webkit-slider-thumb {
      -webkit-box-shadow: 0px 0px 0px #000;
              box-shadow: 0px 0px 0px #000;
      height: 24px;
      width: 24px;
      border: none;
      border-radius: 100%;
      background-color: #81be41;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -10px;
    }
    .loan__slider__widget input[type=range]::-moz-range-track {
      width: 100%;
      height: 5px;
      cursor: pointer;
      animate: 0.2s;
      box-shadow: 0px 0px 0px #000;
      background: #ececec;
      border-radius: 25px;
      border: 0px solid #000101;
    }
    .loan__slider__widget input[type=range]::-moz-range-thumb {
      box-shadow: 0px 0px 0px #000;
      border: 0px solid #000;
      height: 24px;
      width: 24px;
      outline: none;
      border-radius: 100%;
      background: #81be41;
      cursor: pointer;
      margin-top: -14px;
    }
    .loan__slider__widget input[type=range]::-ms-track {
      width: 100%;
      height: 13px;
      cursor: pointer;
      animate: 0.2s;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }
    .loan__slider__widget input[type=range]::-ms-fill-lower {
      background: #ececec;
      border: none;
      border-radius: 50px;
      box-shadow: 0px 0px 0px #000;
    }
    .loan__slider__widget input[type=range]::-ms-fill-upper {
      background: #ececec;
      border: none;
      border-radius: 50px;
      box-shadow: 0px 0px 0px #000;
    }
    .loan__slider__widget input[type=range]::-ms-thumb {
      margin-top: 1px;
      box-shadow: 0px 0px 0px #000;
      border: none;
      height: 24px;
      width: 24px;
      border-radius: 100%;
      background: #81be41;
      cursor: pointer;
    }
    .loan__slider__widget .col-sm-* {
      position: relative;
    }
    @media screen and (min-width: 320px) and (max-width: 400px) {
      .loan__slider__widget .card p.help-block {
        margin-top: 5px;
        font-size: 12px;
      }
    }
    @media screen and (max-width: 320px) {
      .tnk__button {
        width: 100%;
      }
      .tnk__button.button--float-right {
        margin: 10px 0 0;
      }
    }
  `],
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: Router, },
{type: ApiConstant, },
{type: HttpClient, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'referralForm': [{ type: Input, args: ['referralForm', ] },],
'elementState': [{ type: Input, args: ['sliderState', ] },],
'stateURI': [{ type: Input, args: ['stateURI', ] },],
'cookieService': [{ type: Input, args: ['cookieService', ] },],
'createAccountURI': [{ type: Input, args: ['createAccountURI', ] },],
'formURI': [{ type: Input, args: ['formURI', ] },],
'startURI': [{ type: Input, args: ['startURI', ] },],
'sliderOnly': [{ type: Input, args: ['sliderOnly', ] },],
'customerIp': [{ type: Input, args: ['customerIp', ] },],
'referralFormURI': [{ type: Input, args: ['referralFormURI', ] },],
'requestsource': [{ type: Input, args: ['requestsource', ] },],
'sliderColor': [{ type: Input, args: ['sliderColor', ] },],
'encryptedRefCode': [{ type: Input, args: ['encryptedRefCode', ] },],
'micrositePurpose': [{ type: Input, args: ['micrositePurpose', ] },],
'sliderEvent': [{ type: Output, args: ['sliderOnChange', ] },],
'purposeEvent': [{ type: Output, args: ['purposeOnChange', ] },],
};
}

function B2BTNKLoanSliderComponent_tsickle_Closure_declarations() {
/** @type {?} */
B2BTNKLoanSliderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
B2BTNKLoanSliderComponent.ctorParameters;
/** @type {?} */
B2BTNKLoanSliderComponent.propDecorators;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.sliderData;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.state2Form;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.routes;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.agentRoutes;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.invalidSliderForm;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.activeIndexURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.actionBusy;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.errorMsg;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.landingPageSubmitSuccess;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.saveStep1Succeed;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.cardSliderStyle;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.activeForm;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.notFirstApplicant;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.formErrors;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.validationMessages;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.referralForm;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.elementState;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.stateURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.cookieService;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.createAccountURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.formURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.startURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.sliderOnly;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.customerIp;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.referralFormURI;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.requestsource;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.sliderColor;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.encryptedRefCode;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.micrositePurpose;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.sliderEvent;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.purposeEvent;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.fb;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.router;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.api;
/** @type {?} */
B2BTNKLoanSliderComponent.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
